import { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/slices/superAdminSlice';

export default function ProtectedRoute({ allowedRoles }) {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useSelector((state) => state.superAdmin);
  const dispatch = useDispatch();
  useEffect(() => {
    const token = localStorage.getItem('token');
    const role =  JSON.parse(localStorage.getItem('user'))?.role;
    if (!token || !isAuthenticated || role !== 'superAdmin') {
      dispatch(logout());
      navigate('/super-admin-login', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated || !allowedRoles.includes(user?.role)) {
    return null;
  }

  return <Outlet />;
}